/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import {peopleStore,peopleActions} from './store';
import { hashHistory,withRouter } from 'react-router';
import {Button,Dropdown,Icon,Menu,message} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {peopleList,peopleDelete,orgAsyc} from '../../service/people';
import {openNotice} from 'Utils';


class PeopleList extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(peopleStore);
		this.state = {
			opts: ['人员管理'],
			key: 0,
			selectedKeys:[],
			filterBoxVisible: false,
			rows: [],
			total: 0,
			searchObj: {
				account: '',
				name: '',
				status:null,
				p:1,
				s:10
			}
		};

		this.pageChange = this.pageChange.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.goView=this.goView.bind(this);
		this.dropdownClick = this.dropdownClick.bind(this);
		this.getData=this.getData.bind(this);
		this.routeLeaveHook=this.routeLeaveHook.bind(this);
	}

	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		const {searchObj} =this.state;
		let path = nextLocation.pathname.split('/');
		if(path[1] === 'people' && path[2] !== 'add'){ //当下一个路由是详情页时，将useStore的值设为true
			peopleActions.useStoreChange(true);
			peopleActions.paramChange(searchObj);
		}else{
			peopleActions.useStoreChange(false);
			peopleActions.paramChange({});
		}
	}

	componentWillMount () {
		const data = this.store.state;
		if (data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				searchObj:data.storeData
			});
		}
	}

	componentDidMount(){
		this.getData();
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	//获取数据
	getData(){
		var obj=this.state.searchObj;
		peopleList(obj).then(result=>{
			if(result.status){
				for(var i=0;i<result.data.length;i++){
					if(result.data[i].contactInfoList.length>0){
						var contact=result.data[i].contactInfoList;
						for(var j=0;j<contact.length;j++){
							if(contact[j].type==3){
								result.data[i].email=contact[j].content;
								break;
							}
						}
					}
				}
				this.setState({
					rows:result.data,
					total:result.total
				})
			}else{
				message.error(result.message);
			}
		})
	}

	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}

	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}

	advanceReset() {
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: {
				...this.state.searchObj,
				account: '',
				name: '',
				status:null,
				p: 1
			}
		}, () => {
			self.getData();
		});
	};

	advanceSubmit(form) {
		var submitObj=this.state.searchObj;
		submitObj.p=1;
		//有效性选择
		submitObj.status =submitObj.status|| null;
		const self = this;
		this.setState({
			filterBoxVisible: !this.state.filterBoxVisible,
			searchObj: submitObj}, function () {
			self.getData();
		});

	};

	setFilterParam(name, value) {
		this.setState({searchObj: {...this.state.searchObj, [name]: value}})
	};

	pageChange(page, pageSize) {
		const self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.getData();
		});
	}

	onVisibleChange(visible){
		this.setState({
			selectedKeys:[]
		});
	}

	dropdownClick({item, key, keyPath}) {
		const {selectedKeys} =this.state;
		selectedKeys.push(key);
		this.setState({
			selectedKeys
		});
		var arr = key.split('_');
		if (arr[0] === '0') {//删除
			var deleteArr=[];
			deleteArr.push(this.state.rows[arr[1]].id);
			peopleDelete({ids:deleteArr}).then(result=>{
				if(result.status){
					message.success(result.message);
					this.getData();
				}else{
					message.error(result.message);
				}
			})
		};
	}

	menu(index) {
		return <Menu style={{width: "100px", textAlign: 'center'}}
					 onClick={this.dropdownClick}
					 selectedKeys={this.state.selectedKeys}>
			<Menu.Item key={`0_${index}`}>
				删除
			</Menu.Item>
		</Menu>
	}
	asyc(){
		orgAsyc().then(res=>{
			if (res && res.code == 200) {
				openNotice('success', '同步成功,请等待5分钟', '');
			} else {
				openNotice('error', '同步失败', (res && res.message) ? res.message : '');
			}
		});
	}

	render() {
		const {opts, filterBoxVisible, rows, total,searchObj} = this.state;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'account',
						label: '账户',
						defaultValue:searchObj.account,
						text: '请输入账户',
						type: 'default'
					},
					{
						name: 'name',
						label: '姓名',
						defaultValue:searchObj.name,
						text: '请输入姓名',
						type: 'default'
					},{
						name: 'status',
						label: '状态',
						defaultValue:(searchObj.status!=null)?searchObj.status.toString():'',
						options: [
							{value: '', text: '全部'},
							{value: '1', text: '在职'},
							{value: '0', text: '离职'}
						],
						type: 'select'
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total,
				current: this.state.searchObj.p,//当前页码
				pageSize: this.state.searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [{
				title: '账户',
				dataIndex: 'account',
				render: (text, record, index) => <a href={`#/people/detail/${record.id}`}>{text}</a>
			}, {
				title: '姓名',
				dataIndex: 'name',
			}, {
				title: '部门',
				dataIndex: 'organization',
			},{
				title: '岗位',
				dataIndex: 'post',
			},{
				title: '邮箱',
				dataIndex: 'email',
			},{
				title: '状态',
				dataIndex: 'status',
				render: text => text === 1 ? <span style={{color: 'green'}}>在职</span> :
					<span style={{color: '#d61518'}}>离职</span>
			}
			// ,{
			// 	title: '更多操作',
			// 	key: 'action',
   //      		className: 'alignCenter',
			// 	render: (text, record, index) => (
			// 		<Dropdown overlay={this.menu(index)}
			// 				  placement='bottomCenter'
			// 				  trigger={['click']}
			// 				  onVisibleChange={this.onVisibleChange.bind(this)}>
			// 				<span className="ant-dropdown-link">
			// 					<Icon type="caret-down"/>
			// 				</span>
			// 		</Dropdown>
			// 	)
			// }
			],
			rows
		};
		return (
			<div className='dms-body'>
				<div>
					<DmsTab options={opts} defaultKey={0} onChange={this.changeHandle}>
						<Button icon="reload" onClick={this.asyc.bind(this)}>同步</Button>
						{/*<Button icon="plus" onClick={this.goView.bind(this, '/people/add/0')}>新增</Button>*/}
						<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
						<FilterBox  {...filterBoxProps}/>
					</DmsTab>
				</div>

				<div className="dms-table-box">
					<TableView {...tableViewProps} />
				</div>
			</div>
		)
	}
}
export default withRouter ( PeopleList);




// WEBPACK FOOTER //
// ./src/routes/people/list.js